<template>
  <v-dialog v-model="dialog" fullscreen>
    <v-card class="elevation-1" v-if='bill' >
      <v-row no-gutters>
        <v-col cols="4" class="d-flex align-center justify-center">
          <div class="amber darken-1 pa-2 d-flex justify-center">
            <v-img src="../../assets/logo.svg" width="180px"></v-img>
          </div>
        </v-col>
        <v-col cols="8" class="d-flex align-center mt-2">
          <div>
            <p class="text--h3 company-name mt-2 font-weight-bold">
              {{ department.title }}
            </p>
            <p class="subtitle-1 font-italic">
              Địa chỉ: 85 Lương Đình Của, Quận Phương Mai, Ba Đình, Hà Nội
            </p>
          </div>
        </v-col>
      </v-row>

      <div>
        <h2 style="text-align: center;">
          PHIẾU THU HỌC PHÍ
        </h2>
        <p class="caption font-italic" style="text-align: center">
          Liên : {{ bill.code }}
        </p>
      </div>
      <div class="d-flex justify-center">
        <table style="table-layout: fixed">
          <tr>
            <td class="font-italic">Người Nộp Tiền</td>
            <td>{{ bill.customerName }}</td>
          </tr>
          <tr>
            <td class="font-italic">Lý do nộp</td>
            <td>{{ bill.notes }}</td>
          </tr>
          <tr>
            <td class="font-italic">Số tiền</td>
            <td class="font-weight-bold">{{ bill.customerPaid }} vnđ</td>
          </tr>

          <tr>
            <td class="font-italic">Hình thức</td>
            <td>{{ checkPaymentTypes(bill.paymentType)}}</td>
          </tr>
          <tr>
            <td class="font-italic">Bằng chữ</td>
            <td class="font-weight-bold">{{ bill.customerPaid | moneyToString }} đồng</td>
          </tr>
          <tr>
            <td class="font-italic">Ghi chú</td>
            <td>{{bill.notes}}</td>
          </tr>
        </table>
      </div>
      <div class="d-flex justify-space-around">
        <p></p>
        <p class="my-2 font-italic" style="text-align: right">
          {{ bill.date | formatDate }}
        </p>
      </div>
      <div class="d-flex justify-space-around">
        <div>
          <p class="mb-16 font-weight-bold">Người lập phiếu</p>
          <p class="font-weight-bold">{{ bill.staff ? bill.staff.name : '' }}</p>
        </div>
        <div>
          <p class="mb-16 font-weight-bold">Người nộp tiền</p>
          <p class="font-weight-bold">{{ bill.customerName }}</p>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>
<script>

import { mapActions, mapGetters } from 'vuex'
import utils from '@/plugins/utils.js'
import _ from 'lodash'
import moment from 'moment'
export default {
  props: {
    bill: Object,
    state: Boolean,
  },
  created() {
    this.refresh()
  },
  data() {
    return {
      singleSelect: false,
      newProduct: null,
      dialog: false,
      headers: [
        { text: 'Mã Sản Phẩm', align: 'start', sortable: false, value: 'code', },
        { text: 'Sản Phẩm', value: 'title' },
        { text: 'Số Lượng', value: 'quantity' },
        { text: 'Giá', value: 'price' },
        { text: 'Thành Tiền', value: 'total' },
        { text: 'Hành Động', value: 'actions' },
      ],
      products: [],
    }
  },

  computed: {
    ...mapGetters('app', ['department']),
    ...mapGetters('auth', ['profile']),
  },
  methods: {
    ...mapActions('billDetail', ['updateBill']),
    addNewProduct(product) {
      this.products.push(product)
      this.newProduct = null
    },
    deleteProduct(product) {
      this.products = this.products.filter((p) => p.id !== product.id)
    },
    refresh() {
      this.products = _.get(this.bill, 'items', []).map((p) => ({
        ...p,
        quantity: p.quantity || 1,
      }))
    },
    saveBill(bill) {
      this.$emit('updateBill', {
        ...bill,
        data: { ...bill.data, updated: this.profile },
      })
    },
    checkPaymentTypes(typePayment) {
      if (typePayment === 'cash') return 'Tiền mặt'
      if (typePayment === 'bank') return 'Chuyển khoản'
      return ''
    },
  },
  filters: {
    formatMoney(data) {
      return utils.formatMoney(data)
    },
    formatDate(date) {
      return (
        'Hà Nội, ngày ' +
        moment(date).format('DD') +
        ' tháng ' +
        moment(date).format('MM') +
        ' năm ' +
        moment(date).format('YYYY')
      )
    },
    moneyToString(money) {
      return utils.moneyToString(money)
    },
  },
  watch: {
    state(state) {
      let self = this
      this.dialog = true
      setTimeout(() => {
        window.print()
        self.dialog = false
      }, 3000)
    },
    bill() {
      this.refresh()
    },
  },
}
</script>

<style scoped>
.company-name {
  text-transform: uppercase;
  margin-bottom: 2px;
}
td,
th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}
table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 70%;
}
h2{
  font-family: "Times New Roman", Times, serif;
}
</style>
